import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  inject,
} from '@angular/core';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { findPrice } from '@epicuro-next/ataraxia/product-price';
import {
  selectBookmarkIcon,
  selectBookmarkedIcon,
} from '@epicuro-next/platform/configuration';
import { Store, select } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';
import { BehaviorSubject, iif } from 'rxjs';

@Component({
  selector: 'epc-epic-show-presentation-pcard',
  templateUrl: './epic-show-presentation-pcard.component.html',
  styleUrls: ['./epic-show-presentation-pcard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EpicShowPresentationPcardComponent {
  private store = inject(Store);
  public imageMaxSizes = IMAGE_MAX_SIZES;

  @Input()
  public product: Product;

  @Input()
  public showWholeSalePrices = true;

  @Input()
  public titleFields: string[];

  @Input()
  public idFields: string[];

  @Input()
  public isInActiveList = false;

  @Output()
  public addToListClicked = new EventEmitter<Product>();

  @Output()
  public openCStripClicked = new EventEmitter<Product>();

  public expanded$$ = new BehaviorSubject(false);

  @HostListener('mouseenter')
  public onMouseEnter() {
    this.expanded$$.next(true);
  }

  @HostListener('mouseleave')
  public onMouseLeave() {
    this.expanded$$.next(false);
  }

  public addToListIcon$ = iif(
    () => this.isInActiveList,
    this.store.pipe(select(selectBookmarkedIcon)),
    this.store.pipe(select(selectBookmarkIcon)),
  );

  public get price() {
    const result = findPrice(this.product.priceRanges);

    return {
      ...result,
      wspd: null,
    };
  }
}
